import script from "./HistoryComponentBox.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryComponentBox.vue?vue&type=script&setup=true&lang=js"

import "./HistoryComponentBox.vue?vue&type=style&index=0&id=8d4f2d1c&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\AI Inventory\\codebase\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d4f2d1c"]])

export default __exports__